import styled from "styled-components";

export const TagSpan = styled.span`
	background: #e20014;
	color: #fff;
	border-radius: 16px;
	padding: 1px 10px;
	font-size: 12px;
	display: inline-block;
	font-weight: 500;
	margin-left: 5px;
`;
